import {
  AxiosMethod,
  defaultAxiosOptions,
  serviceEndpoints,
} from '../../constants';
import { CountryModel } from '../../models';
import { AxiosRequestConfig } from 'axios';
import useAxios from 'axios-hooks';
import { useNetworkErrorHandler } from '../../store/reducers/popupAlertsReducer';
import { ResponseValuesOverride } from '../../models/response-values-override';

export function useGetCountries(): ResponseValuesOverride<CountryModel[]> {
  const config: AxiosRequestConfig = {
    method: AxiosMethod.Get,
    url: serviceEndpoints.offerGeoCountriesApi(),
  };

  const [resp] = useAxios<CountryModel[]>(config, {
    ...defaultAxiosOptions,
    manual: false,
  });

  useNetworkErrorHandler(resp.error);

  return {
    ...resp,
    data: (resp.data || []).filter(
      (country): boolean => country.name && country.name.length > 1,
    ),
  };
}
